document.documentElement.classList.add("js", "kura-lp-active");
document.body.classList.add("kura-lp-page");

const root = document.getElementById("kura-lp-root");
if (!root) throw new Error("KURA LP root was not found.");

root.querySelectorAll("[data-layer]").forEach((layer) => {
  const design = layer.closest("[data-design]");
  const designWidth = Number(design?.dataset.designWidth || 393);
  const designHeight = Number(design?.dataset.designHeight || 1);
  const x = Number(layer.dataset.x || 0);
  const y = Number(layer.dataset.y || 0);
  const w = Number(layer.dataset.w || 0);
  const h = Number(layer.dataset.h || 0);

  layer.style.left = `${(x / designWidth) * 100}%`;
  layer.style.top = `${(y / designHeight) * 100}%`;
  layer.style.width = `${(w / designWidth) * 100}%`;
  layer.style.height = `${(h / designHeight) * 100}%`;
});

const desktopMedia = window.matchMedia("(min-width: 900px)");
const loadDesktopGallery = () => {
  if (!desktopMedia.matches) return;

  root.querySelectorAll("[data-desktop-src]").forEach((image) => {
    if (!image.getAttribute("src")) {
      image.src = image.dataset.desktopSrc;
    }
  });
};

loadDesktopGallery();
desktopMedia.addEventListener?.("change", loadDesktopGallery);

root.querySelectorAll("[data-rice-switcher]").forEach((switcher) => {
  const images = Array.from(switcher.querySelectorAll("[data-rice-view]"));
  const views = [...new Set(images.map((image) => image.dataset.riceView))];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let currentIndex = Math.max(0, views.indexOf(switcher.dataset.view));
  let timer = null;

  const showView = (view) => {
    switcher.dataset.view = view;
    currentIndex = Math.max(0, views.indexOf(view));

    images.forEach((image) => {
      image.classList.toggle("is-active", image.dataset.riceView === view);
    });
  };

  const stopAutoSwitch = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  const startAutoSwitch = () => {
    stopAutoSwitch();
    if (reduceMotion.matches || views.length < 2) return;

    timer = window.setInterval(() => {
      currentIndex = (currentIndex + 1) % views.length;
      showView(views[currentIndex]);
    }, 3400);
  };
  reduceMotion.addEventListener?.("change", startAutoSwitch);

  showView(views[currentIndex]);
  startAutoSwitch();
});

const pageVideos = Array.from(root.querySelectorAll("video")).filter((video) => !video.closest(".movie-modal"));

const loadVideo = (video) => {
  if (video.dataset.loaded === "true") return;

  let hasDeferredSource = false;
  video.querySelectorAll("source[data-src]").forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute("data-src");
    hasDeferredSource = true;
  });

  if (hasDeferredSource) {
    video.load();
  }

  video.dataset.loaded = "true";
};

const playVideo = (video) => {
  loadVideo(video);
  const request = video.play();
  if (request && typeof request.catch === "function") {
    request.catch(() => {});
  }
};

pageVideos.forEach((video) => {
  const markReady = () => {
    video.classList.add("is-ready");

    if (video.closest(".kv-video")) {
      root.querySelector(".kv-logo-lockup")?.classList.add("is-ready");
    }
  };

  video.addEventListener("loadeddata", markReady, { once: true });
  video.addEventListener("canplay", markReady, { once: true });

  if (video.readyState >= 2) {
    markReady();
  }
});

if ("IntersectionObserver" in window) {
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    },
    {
      root: null,
      rootMargin: "260px 0px 260px 0px",
      threshold: 0.08,
    }
  );

  pageVideos.forEach((video) => videoObserver.observe(video));
} else {
  pageVideos.forEach((video) => {
    loadVideo(video);
    playVideo(video);
  });
}

const revealTargets = root.querySelectorAll(".section-reveal");
const graphTargets = root.querySelectorAll(".animated-graph");

if ("IntersectionObserver" in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -12% 0px",
      threshold: 0.08,
    }
  );

  revealTargets.forEach((target) => revealObserver.observe(target));
} else {
  revealTargets.forEach((target) => target.classList.add("is-visible"));
}

if ("IntersectionObserver" in window) {
  const graphObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          graphObserver.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -18% 0px",
      threshold: 0.22,
    }
  );

  graphTargets.forEach((target) => graphObserver.observe(target));
} else {
  graphTargets.forEach((target) => target.classList.add("is-visible"));
}

const movieModal = root.querySelector("#movie-modal");
const movieModalVideo = movieModal?.querySelector(".movie-modal__video");
const movieCloseButtons = movieModal?.querySelectorAll("[data-movie-close]") || [];
let lastMovieTrigger = null;

const closeMovieModal = () => {
  if (!movieModal || !movieModalVideo) return;

  movieModal.classList.remove("is-open");
  movieModal.setAttribute("aria-hidden", "true");
  document.documentElement.classList.remove("modal-lock");
  movieModalVideo.pause();
  movieModalVideo.removeAttribute("src");
  movieModalVideo.removeAttribute("poster");
  movieModalVideo.load();

  if (lastMovieTrigger) {
    lastMovieTrigger.focus({ preventScroll: true });
    lastMovieTrigger = null;
  }
};

root.querySelectorAll(".ugc-open").forEach((button) => {
  button.addEventListener("click", () => {
    const previewVideo = button.querySelector("video");
    const previewSource = previewVideo?.querySelector("source");
    const source = button.dataset.movieSrc || previewSource?.getAttribute("src") || previewSource?.dataset.src;
    if (!movieModal || !movieModalVideo || !source) return;

    lastMovieTrigger = button;
    movieModalVideo.src = source;
    movieModalVideo.poster = previewVideo.getAttribute("poster") || "";
    movieModalVideo.currentTime = 0;
    movieModal.classList.add("is-open");
    movieModal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("modal-lock");
    movieModalVideo.focus({ preventScroll: true });

    const request = movieModalVideo.play();
    if (request && typeof request.catch === "function") {
      request.catch(() => {});
    }
  });
});

movieCloseButtons.forEach((button) => {
  button.addEventListener("click", closeMovieModal);
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && movieModal?.classList.contains("is-open")) {
    closeMovieModal();
  }
});

const purchaseCatalog = {
  "5kg": {
    price: 19800,
    variants: {
      "ホワイト": 45923186966630,
      "ブラック": 45923186999398,
      "ブラウン": 45923187032166,
    },
  },
  "7.5kg": {
    price: 26800,
    variants: {
      "ホワイト": 45923187097702,
      "ブラック": 45923187130470,
      "ブラウン": 45923187163238,
    },
  },
  "10kg": {
    price: 29800,
    variants: {
      "ホワイト": 45923191128166,
      "ブラック": 45923191160934,
      "ブラウン": 45923191193702,
    },
  },
};

const purchaseDrawer = root.querySelector("#purchase-configurator");
const purchasePanel = purchaseDrawer?.querySelector(".purchase-drawer__panel");
const purchaseOpeners = root.querySelectorAll("[data-purchase-open]");
const purchaseClosers = purchaseDrawer?.querySelectorAll("[data-purchase-close]") || [];
const purchaseSizeButtons = purchaseDrawer?.querySelectorAll("[data-purchase-size]") || [];
const purchaseColorButtons = purchaseDrawer?.querySelectorAll("[data-purchase-color]") || [];
const purchaseSelection = purchaseDrawer?.querySelector("[data-purchase-selection]");
const purchasePrice = purchaseDrawer?.querySelector("[data-purchase-price]");
const purchaseSubmit = purchaseDrawer?.querySelector("[data-purchase-submit]");
const purchaseStatus = purchaseDrawer?.querySelector("[data-purchase-status]");
const purchaseImages = purchaseDrawer?.querySelectorAll("[data-purchase-image]") || [];
const guideConfirmation = purchaseDrawer?.querySelector("[data-guide-confirmation]");
const purchaseCapacity = purchaseDrawer?.querySelector("[data-purchase-capacity]");
const capacityNotes = {
  "5kg": "保存量の目安：約5kg。仕分けケースは付属しません。",
  "7.5kg": "ケースなし：約7.5kg ／ 仕分け時：約3.5kg＋約1.5kg。",
  "10kg": "ケースなし：約10kg ／ 仕分け時：約5kg＋約2.5kg。",
};
const priceFormatter = new Intl.NumberFormat("ja-JP");
let selectedPurchaseSize = "5kg";
let selectedPurchaseColor = "ホワイト";
let lastPurchaseTrigger = null;
let purchaseCloseTimer = null;

const updatePurchaseSummary = () => {
  const product = purchaseCatalog[selectedPurchaseSize];
  if (!product || !purchaseSelection || !purchasePrice) return;

  purchaseSelection.textContent = `${selectedPurchaseSize}・${selectedPurchaseColor}`;
  purchasePrice.textContent = `¥${priceFormatter.format(product.price)}`;
  if (purchaseCapacity) purchaseCapacity.textContent = capacityNotes[selectedPurchaseSize];
  const selectedImageKey = `${selectedPurchaseSize}|${selectedPurchaseColor}`;
  purchaseImages.forEach((image) => {
    image.classList.toggle("is-active", image.dataset.purchaseImage === selectedImageKey);
  });
  if (purchaseStatus) purchaseStatus.textContent = "";
};

const selectPurchaseOption = (buttons, activeButton) => {
  buttons.forEach((button) => {
    const isSelected = button === activeButton;
    button.classList.toggle("is-selected", isSelected);
    button.setAttribute("aria-pressed", String(isSelected));
  });
};

const openPurchaseDrawer = (trigger) => {
  if (!purchaseDrawer) return;

  if (purchaseCloseTimer) {
    window.clearTimeout(purchaseCloseTimer);
    purchaseCloseTimer = null;
  }

  lastPurchaseTrigger = trigger || null;
  purchaseDrawer.hidden = false;
  purchaseDrawer.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("purchase-lock");
  window.requestAnimationFrame(() => {
    purchaseDrawer.classList.add("is-open");
    purchaseDrawer.querySelector("[data-purchase-size].is-selected")?.focus({ preventScroll: true });
  });
};

const closePurchaseDrawer = () => {
  if (!purchaseDrawer || purchaseDrawer.hidden) return;

  purchaseDrawer.classList.remove("is-open");
  purchaseDrawer.setAttribute("aria-hidden", "true");
  document.documentElement.classList.remove("purchase-lock");
  purchaseCloseTimer = window.setTimeout(() => {
    purchaseDrawer.hidden = true;
    purchaseCloseTimer = null;
  }, 230);

  lastPurchaseTrigger?.focus({ preventScroll: true });
  lastPurchaseTrigger = null;
};

purchaseOpeners.forEach((opener) => {
  opener.addEventListener("click", (event) => {
    event.preventDefault();
    openPurchaseDrawer(opener);
  });
});

purchaseClosers.forEach((closer) => {
  closer.addEventListener("click", closePurchaseDrawer);
});

purchaseSizeButtons.forEach((button) => {
  button.addEventListener("click", () => {
    selectedPurchaseSize = button.dataset.purchaseSize;
    selectPurchaseOption(purchaseSizeButtons, button);
    if (guideConfirmation) guideConfirmation.hidden = true;
    updatePurchaseSummary();
  });
});

purchaseColorButtons.forEach((button) => {
  button.addEventListener("click", () => {
    selectedPurchaseColor = button.dataset.purchaseColor;
    selectPurchaseOption(purchaseColorButtons, button);
    updatePurchaseSummary();
  });
});

purchaseSubmit?.addEventListener("click", () => {
  const variantId = purchaseCatalog[selectedPurchaseSize]?.variants[selectedPurchaseColor];
  if (!variantId) {
    if (purchaseStatus) purchaseStatus.textContent = "商品を選び直してください。";
    return;
  }

  purchaseSubmit.disabled = true;
  purchaseSubmit.textContent = "カートへ移動しています";
  window.location.assign(`https://everyu-official.com/cart/${variantId}:1`);
});

window.addEventListener("pageshow", () => {
  if (!purchaseSubmit) return;
  purchaseSubmit.disabled = false;
  purchaseSubmit.textContent = "カートに入れる";
});

document.addEventListener("keydown", (event) => {
  if (root.querySelector("#size-guide")?.open) return;
  if (event.key === "Escape" && purchaseDrawer?.classList.contains("is-open")) {
    closePurchaseDrawer();
  }

  if (event.key !== "Tab" || !purchaseDrawer?.classList.contains("is-open") || !purchasePanel) return;

  const focusable = Array.from(
    purchasePanel.querySelectorAll("button:not([disabled]), a[href]")
  ).filter((element) => element.offsetParent !== null);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

updatePurchaseSummary();

window.KuraSizeGuide?.({
  scope: purchaseDrawer?.parentElement || document,
  getPrice: (size) => purchaseCatalog[size].price,
  getColor: () => selectedPurchaseColor,
  getImage: (size, color) => Array.from(purchaseImages).find((image) => image.dataset.purchaseImage === `${size}|${color}`)?.src,
  onApply: (size, opener) => {
    selectedPurchaseSize = size;
    const button = Array.from(purchaseSizeButtons).find((item) => item.dataset.purchaseSize === size);
    selectPurchaseOption(purchaseSizeButtons, button);
    updatePurchaseSummary();
    if (guideConfirmation) {
      guideConfirmation.textContent = `診断のおすすめ：${size}を選択しました。`;
      guideConfirmation.hidden = false;
    }
    if (purchaseDrawer.hidden) openPurchaseDrawer(opener);
    return button;
  },
});

const retailRoot = root;
const retailOpeners = retailRoot.querySelectorAll("[data-retail-open]");
const storeModal = retailRoot.querySelector("#store-modal");
const storePanel = storeModal?.querySelector(".store-modal__panel");
const storeClosers = storeModal?.querySelectorAll("[data-store-close]") || [];
const storeSearch = storeModal?.querySelector("[data-store-search]");
const storeCount = storeModal?.querySelector("[data-store-count]");
const storeList = storeModal?.querySelector("[data-store-list]");
const prefectureOrder = [
  "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県",
  "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
  "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県",
  "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県",
  "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県",
  "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県",
  "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県",
];
let retailStores = null;
let retailStoresPromise = null;
let lastRetailTrigger = null;
let storeCloseTimer = null;

const normalizeStoreSearch = (value) => String(value || "")
  .normalize("NFKC")
  .toLocaleLowerCase("ja-JP")
  .replace(/\s+/g, "");

const createStoreElement = (tag, className, text) => {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
};

const renderStoreList = () => {
  if (!storeList || !storeCount || !retailStores) return;

  const query = normalizeStoreSearch(storeSearch?.value);
  const filteredStores = retailStores.filter((store) => {
    if (!query) return true;
    return normalizeStoreSearch([
      store.name,
      store.prefecture,
      store.postal,
      store.tel,
      store.address,
    ].join(" ")).includes(query);
  });

  storeCount.textContent = query
    ? `${filteredStores.length}店舗が見つかりました`
    : `掲載 ${retailStores.length}店舗`;
  storeList.replaceChildren();

  if (!filteredStores.length) {
    storeList.append(createStoreElement("p", "store-modal__empty", "該当する店舗が見つかりませんでした。"));
    return;
  }

  const storesByPrefecture = new Map();
  filteredStores.forEach((store) => {
    const group = storesByPrefecture.get(store.prefecture) || [];
    group.push(store);
    storesByPrefecture.set(store.prefecture, group);
  });

  const sortedPrefectures = Array.from(storesByPrefecture.keys()).sort((a, b) => {
    const aIndex = prefectureOrder.indexOf(a);
    const bIndex = prefectureOrder.indexOf(b);
    return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
  });

  const fragment = document.createDocumentFragment();
  sortedPrefectures.forEach((prefecture) => {
    const stores = storesByPrefecture.get(prefecture);
    const details = createStoreElement("details", "store-group");
    details.open = Boolean(query);

    const summary = createStoreElement("summary");
    summary.append(
      createStoreElement("span", "", prefecture),
      createStoreElement("small", "", `${stores.length}店舗`)
    );
    details.append(summary);

    const items = createStoreElement("div", "store-group__items");
    stores.forEach((store) => {
      const card = createStoreElement("article", "store-card");
      card.append(createStoreElement("h3", "", store.name));

      const address = createStoreElement("p");
      address.append(document.createTextNode(`〒${store.postal}`), document.createElement("br"), document.createTextNode(store.address));
      card.append(address);

      if (store.tel) {
        const telephone = createStoreElement("a", "", store.tel);
        telephone.href = `tel:${store.tel.replace(/[^\d+]/g, "")}`;
        telephone.setAttribute("aria-label", `${store.name}へ電話 ${store.tel}`);
        card.append(telephone);
      }
      items.append(card);
    });

    details.append(items);
    fragment.append(details);
  });
  storeList.append(fragment);
};

const loadRetailStores = async (source) => {
  if (retailStores) return retailStores;
  if (retailStoresPromise) return retailStoresPromise;

  retailStoresPromise = fetch(source, { credentials: "same-origin" })
    .then((response) => {
      if (!response.ok) throw new Error(`Store list request failed: ${response.status}`);
      return response.json();
    })
    .then((payload) => {
      if (!Array.isArray(payload.stores)) throw new Error("Store list data is invalid.");
      retailStores = payload.stores;
      renderStoreList();
      return retailStores;
    })
    .catch((error) => {
      retailStoresPromise = null;
      if (storeCount) storeCount.textContent = "";
      if (storeList) {
        storeList.replaceChildren(createStoreElement("p", "store-modal__error", "店舗一覧を読み込めませんでした。時間をおいて再度お試しください。"));
      }
      console.error(error);
      throw error;
    });

  return retailStoresPromise;
};

const openStoreModal = (trigger) => {
  if (!storeModal) return;
  if (storeCloseTimer) {
    window.clearTimeout(storeCloseTimer);
    storeCloseTimer = null;
  }

  lastRetailTrigger = trigger || null;
  storeModal.hidden = false;
  storeModal.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("store-modal-lock");
  if (storePanel) storePanel.scrollTop = 0;
  if (storeSearch) storeSearch.value = "";

  window.requestAnimationFrame(() => {
    storeModal.classList.add("is-open");
    storeSearch?.focus({ preventScroll: true });
  });

  const source = trigger?.dataset.storeSrc;
  if (source) {
    if (retailStores) renderStoreList();
    else loadRetailStores(source).catch(() => {});
  }
};

const closeStoreModal = () => {
  if (!storeModal || storeModal.hidden) return;

  storeModal.classList.remove("is-open");
  storeModal.setAttribute("aria-hidden", "true");
  document.documentElement.classList.remove("store-modal-lock");
  storeCloseTimer = window.setTimeout(() => {
    storeModal.hidden = true;
    storeCloseTimer = null;
  }, 230);

  lastRetailTrigger?.focus({ preventScroll: true });
  lastRetailTrigger = null;
};

retailOpeners.forEach((opener) => {
  opener.addEventListener("click", () => openStoreModal(opener));
});

storeClosers.forEach((closer) => {
  closer.addEventListener("click", closeStoreModal);
});

storeSearch?.addEventListener("input", renderStoreList);

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && storeModal?.classList.contains("is-open")) {
    closeStoreModal();
    return;
  }

  if (event.key !== "Tab" || !storeModal?.classList.contains("is-open") || !storePanel) return;
  const focusable = Array.from(
    storePanel.querySelectorAll("button:not([disabled]), input:not([disabled]), summary, a[href]")
  ).filter((element) => element.offsetParent !== null);
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});
